import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL;
const baseHeaders = {
  'Access-Control-Allow-Origin': '*',
  'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS',
  'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
  'Authorization': ''
};

const MAX_ATTEMPTS = 5;

// Junta o path garantindo exatamente 1 barra entre eles
function joinPath() {
  const parts = Array.from(arguments)
    .filter(Boolean)
    .map(p => String(p).replace(/^\/+|\/+$/g, ''));
  return '/' + parts.join('/');
}

async function retryAxiosRequest(axiosConfig, attempts = MAX_ATTEMPTS) {
  let lastError;
  for (let i = 0; i < attempts; i++) {
    try {
      const response = await axios.request(axiosConfig);
      return response.data;
    } catch (error) {
      lastError = error;
      await new Promise(res => setTimeout(res, 1000));
    }
  }
  const apiError = {
    ...lastError,
    code: lastError.response?.status,
    details: lastError.response?.data,
  };
  throw apiError;
}

async function requestAxios(method, controller, url, params, token) {
  const headers = { ...baseHeaders };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  if (url === 'upload-files') {
    headers['Content-Type'] = 'multipart/form-data';
  }

  const path = joinPath(controller, url);

  const axiosConfig = {
    baseURL: baseURL,
    method,
    url: path,
    headers,
    data: params,
  };

  return retryAxiosRequest(axiosConfig);
}

async function requestAxiosURL(method, url, params, token) {
  const headers = { ...baseHeaders };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const axiosConfig = {
    method,
    url,
    headers,
    data: params,
  };

  return retryAxiosRequest(axiosConfig);
}

export { requestAxios, requestAxiosURL };
